import { render, staticRenderFns } from "./SalidasIndex.vue?vue&type=template&id=45d2f6cc&scoped=true&"
import script from "./SalidasIndex.vue?vue&type=script&lang=ts&"
export * from "./SalidasIndex.vue?vue&type=script&lang=ts&"
import style0 from "./SalidasIndex.vue?vue&type=style&index=0&id=45d2f6cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2f6cc",
  null
  
)

export default component.exports